module.exports = __webpack_public_path__ + "media/images/icons/SVG/029-48c38cba35fcb0e0014053d8e4e088a5.svg";